module.exports = __webpack_public_path__ + "media/src/public/img/popup-heart-ec8b555058d8dbf1943fc7ff72c0bdb4.webp";